/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina } from './PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina';
import {
  PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelinaFromJSON,
  PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelinaFromJSONTyped,
  PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelinaToJSON,
} from './PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina';
import type { PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit } from './PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit';
import {
  PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKitFromJSON,
  PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKitFromJSONTyped,
  PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKitToJSON,
} from './PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit';

/**
 * @type PatchedVoiceAgentInferencerPolymorphic
 *
 * @export
 */
export type PatchedVoiceAgentInferencerPolymorphic =
  | ({ protocol: 'CELINA' } & PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina)
  | ({ protocol: 'LIVEKIT' } & PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit);

export function PatchedVoiceAgentInferencerPolymorphicFromJSON(json: any): PatchedVoiceAgentInferencerPolymorphic {
  return PatchedVoiceAgentInferencerPolymorphicFromJSONTyped(json, false);
}

export function PatchedVoiceAgentInferencerPolymorphicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedVoiceAgentInferencerPolymorphic {
  if (json == null) {
    return json;
  }
  switch (json['protocol']) {
    case 'CELINA':
      return Object.assign(
        {},
        PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelinaFromJSONTyped(json, true),
        { protocol: 'CELINA' } as const,
      );
    case 'LIVEKIT':
      return Object.assign(
        {},
        PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKitFromJSONTyped(json, true),
        { protocol: 'LIVEKIT' } as const,
      );
    default:
      throw new Error(
        `No variant of PatchedVoiceAgentInferencerPolymorphic exists with 'protocol=${json['protocol']}'`,
      );
  }
}

export function PatchedVoiceAgentInferencerPolymorphicToJSON(
  value?: PatchedVoiceAgentInferencerPolymorphic | null,
): any {
  if (value == null) {
    return value;
  }
  switch (value['protocol']) {
    case 'CELINA':
      return PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelinaToJSON(value);
    case 'LIVEKIT':
      return PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKitToJSON(value);
    default:
      throw new Error(
        `No variant of PatchedVoiceAgentInferencerPolymorphic exists with 'protocol=${value['protocol']}'`,
      );
  }
}
